<template>
  <div class="pcm-wrapper" id="pcm-wrapper">
    <div class="topScrim"></div>
    <div class="nav">
      <div class="logoWrap">
        <div class="logoIcon"></div>
        <div class="logoText">花魁短剧</div>
      </div>
      <div class="navRight">
        <div class="contactBox">
          <div class="telegram" v-if="cTg" @click="jumpUrl(cTg)"></div>
          <div class="potato" v-if="cPotato" @click="jumpUrl(cPotato)"></div>
          <div
            class="business"
            v-if="cBusiness"
            @click="jumpUrl(cBusiness)"
          ></div>
          <div class="channel" v-if="cChannel" @click="jumpUrl(cChannel)"></div>
          <!-- <div class="customer" @click="openOnlineService"></div> -->
        </div>
      </div>
    </div>
    <div class="hero">
      <div class="copyBox">
        <div class="tags">
          <div class="tag">原创短剧</div>
          <div class="tag">每日上新</div>
          <div class="tag">高清秒播</div>
        </div>
        <div class="heroTitle"></div>
        <div class="subTitle">
          三分钟一集，好剧停不下来，海量原创短剧每日更新，免费看，不卡顿
        </div>
        <div class="cta">
          <div class="qrBox">
            <img class="qrcode" :src="qrImg" alt="" />
          </div>
          <div class="ctaText">
            <div class="ctaMain">手机扫码下载 App</div>
            <div class="ctaSub">支持 iOS 与 Android</div>
            <div class="ctaTip">免费下载&nbsp;&nbsp;每日更新</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";
import getCustomerServiceUrl from "@/api/getCustomerServiceUrl";
import {
  getDeviceType,
  getSystemType,
  getSystemVersion,
  getTraceId,
} from "@/utils/eventTracker";

const APPID = 216;

autofit.init();
export default {
  props: ["qrImg", "configs"],
  data() {
    return {
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      onlineServiceLoading: false,
    };
  },
  watch: {
    configs(configs) {
      configs.forEach((item) => {
        if (item.configType === "tg_group") {
          this.cTg = item.link;
        } else if (item.configType === "potato_group") {
          this.cPotato = item.link;
        } else if (item.configType === "sw_cooperate") {
          this.cBusiness = item.link;
        } else if (item.configType === "qd_cooperate") {
          this.cChannel = item.link;
        }
      });
      return configs;
    },
  },
  mounted() {
    autofit.init(
      {
        dh: 720,
        dw: 1440,
        el: "#pcm-wrapper",
        resize: true,
      },
      false
    ); // 可关闭控制台运行提示输出
  },
  methods: {
    async openOnlineService() {
      if (this.onlineServiceLoading) {
        return;
      }
      this.onlineServiceLoading = true;
      try {
        const res = await getCustomerServiceUrl({
          uid: this.$route.query.uid || getTraceId(),
          appId: APPID,
          deviceType: getDeviceType(),
          systemType: getSystemType(),
          systemVersion: getSystemVersion(),
        });
        const serviceUrl = res && res.data && res.data.data;
        if (serviceUrl) {
          window.open(serviceUrl);
          return;
        }
        if (this.cChannel) {
          window.open(this.cChannel);
        }
      } catch (error) {
        if (this.cChannel) {
          window.open(this.cChannel);
        }
        console.log("get customer service url error:", error);
      } finally {
        this.onlineServiceLoading = false;
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.pcm-wrapper {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #141414 url("../../../assets/images/pc/heroBg.webp") no-repeat
    center;
  background-size: cover;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  .topScrim {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 180px;
    background: linear-gradient(
      180deg,
      #141414 0%,
      rgba(20, 20, 20, 0.6) 35%,
      rgba(20, 20, 20, 0) 100%
    );
    pointer-events: none;
  }
  .nav {
    position: relative;
    z-index: 10;
    height: 72px;
    padding: 0 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    .logoWrap {
      display: flex;
      align-items: center;
      .logoIcon {
        width: 32px;
        height: 32px;
        margin-right: 8px;
        background: url("../../../assets/images/pc/logoIcon.png") no-repeat;
        background-size: 100% 100%;
      }
      .logoText {
        color: #fff;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        white-space: nowrap;
      }
    }
    .navRight {
      display: flex;
      align-items: center;
    }
    .contactBox {
      display: flex;
      align-items: center;
      .telegram,
      .potato,
      .business,
      .channel,
      .customer {
        width: 40px;
        height: 40px;
        margin-right: 16px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &:last-child {
          margin-right: 0;
        }
      }
      .telegram {
        background-image: url("../../../assets/images/pc/telegram.png");
      }
      .potato {
        background-image: url("../../../assets/images/pc/potato.png");
      }
      .business {
        background-image: url("../../../assets/images/pc/shangwu.png");
      }
      .channel {
        background-image: url("../../../assets/images/pc/qudao.png");
      }
      .customer {
        background-image: url("../../../assets/images/pc/customer.png");
      }
    }
  }
  .hero {
    position: relative;
    z-index: 10;
    flex: 1;
    padding: 88px 120px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .copyBox {
    width: 619px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .tags {
      display: flex;
      .tag {
        height: 28px;
        padding: 0 12px;
        margin-left: 8px;
        display: flex;
        align-items: center;
        border-radius: 999px;
        background: rgba(255, 15, 83, 0.16);
        color: #ff3d74;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        white-space: nowrap;
      }
    }
    .heroTitle {
      width: 664px;
      height: 230px;
      margin-top: 24px;
      background: url("../../../assets/images/pc/heroTitle.webp") no-repeat;
      background-size: 100% 100%;
    }
    .subTitle {
      margin-top: 24px;
      color: #b9bbc2;
      font-size: 20px;
      font-weight: 600;
      line-height: 22px;
      text-align: right;
      white-space: nowrap;
    }
    .cta {
      margin-top: 24px;
      display: flex;
      align-items: center;
      .qrBox {
        padding: 4px;
        margin-right: 20px;
        border-radius: 12px;
        background: #fff;
        .qrcode {
          display: block;
          width: 88px;
          height: 88px;
        }
      }
      .ctaText {
        display: flex;
        flex-direction: column;
        white-space: nowrap;
        .ctaMain {
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
        .ctaSub {
          margin-top: 8px;
          color: #b9bbc2;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }
        .ctaTip {
          margin-top: 8px;
          color: #7e818b;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
